import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BaseRateValidation } from 'uplisting-frontend/validations';

export default class BaseRateRepositoryService extends BaseRepositoryService<
  ModelRegistry['base-rate']
> {
  recordName = 'base-rate';
  implementMethods = ['buildChangeset'];

  validation = BaseRateValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/base-rate': BaseRateRepositoryService;
  }
}
